/**
 * @format
 * @Organizerat
 */

import { useContext, useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

import Master from '../Layouts/Master';
import ModalCustom from '../../Shared/Components/ModalCustom';
import { EventContext } from '../../Contexts/EventContext';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import Pagination from '../../Shared/Components/Pagination';

const Organizer = () => {
	const eventContext = useContext(EventContext);
	const { search } = useLocation();
	const [loading, setLoading] = useState(false);
	const [removeLoading, setRemoveLoading] = useState(false);
	const [organizerRemoveId, setOrganizerRemoveId] = useState();
	const [modalIsOpen, setModalIsOpen] = useState(false);

	useEffect(() => {
		getOrganizer();
	}, [search]);
	const getOrganizer = async () => {
		setLoading(true);
		await useApi.get(
			`/organizer/${search}`,
			{},
			(res) => {
				eventContext.organizers = res.data;
				setLoading(false);
			},
			(err) => {
				setLoading(false);
				error('هنگام دریافت اطلاعات خطایی رخ داده است');
			},
		);
	};
	const removeOrganizer = async (organizerId) => {
		setRemoveLoading(true);

		await useApi.delete(
			`/organizer/${organizerId}`,
			{},
			(res) => {
				success('برگزار کننده مورد نظر با موفقیت حذف شد');
				setRemoveLoading(false);
				setModalIsOpen(false);
				getOrganizer();
			},
			(err) => {
				setRemoveLoading(false);
				setLoading(false);
				error('حذف به علت خطا انجام نشد');
			},
		);
	};

	return (
		<Master>
			<div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
				<div className='d-flex flex-row mt-2'>
					<i className='fad fa-list f-20 text-secondary mx-2'></i>
					<h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
						لیست برگزارکنندگان
					</h1>
				</div>
				<Link
					to='/panel/organizer/create'
					className='d-flex flex-row btn btn-outline-info '>
					<i className='fad fa-plus f-16 mx-2'></i>
					<span className='f-13'>ایجاد برگزار کننده</span>
				</Link>
			</div>
			<div className='w-100 overflow-auto'>
				{eventContext.organizers?.data?.length > 0 ? (
					<table className='table table-hover'>
						<thead>
							<tr>
								<th>#</th>
								<th>عنوان</th>
								<th>عملیات</th>
							</tr>
						</thead>
						<tbody>
							{eventContext.organizers?.data?.map((item) => (
								<tr key={item.id}>
									<th>{item.id}</th>
									<td>{item.name}</td>
									<td>
										<div className='d-flex flex-row'>
											<Link
												to={`/panel/organizer/edit/${item.id}`}
												className='mx-2'>
												ویرایش
											</Link>
											<Link
												className='mx-2'
												to='#'
												onClick={(e) => {
													e.preventDefault();
													setOrganizerRemoveId(item.id);
													setModalIsOpen(true);
												}}>
												حذف
											</Link>
										</div>
									</td>
								</tr>
							))}
						</tbody>
					</table>
				) : (
					<div className='d-flex flex-row justify-content-center border p-3 my-3	'>
						<i className='fad fa-plus f-16 mx-2 text-secondary'></i>
						<span className='f-13 font-weight-bold text-secondary'>
							برای ایجاد برگزار کننده بر روی منوی ایجاد برگزار کننده کلیک کنید
						</span>
					</div>
				)}
			</div>
			<div className='w-100 mt-4 d-flex'>
				<Pagination meta={eventContext.organizers?.meta} />
			</div>
			<ModalCustom modalIsOpen={modalIsOpen}>
				<div className='d-flex flex-row border-bottom pb-2'>
					<i className='fad fa-warning f-20 mx-2'></i>
					<span className=''>آیا از حذف برگزار کننده مطمئنید‌؟</span>
				</div>
				<div className='d-flex flex-row justify-content-around my-3'>
					<button
						onClick={() => setModalIsOpen(false)}
						className='btn btn-danger w-48 f-13'>
						لغو
					</button>
					<button
						onClick={() => removeOrganizer(organizerRemoveId)}
						className='btn btn-success w-48 f-13'>
						{removeLoading ? (
							<div
								className='spinner-border spinner-border-sm text-white mb-1'
								role='status'></div>
						) : (
							'بله'
						)}
					</button>
				</div>
			</ModalCustom>
		</Master>
	);
};

export default Organizer;
